<template>
  <div class="container h-100">
    <div class="row">
      <div class="col-12 mt-5 mb-4">
        <img
          :src="
            $store.state.company_data && $store.state.company_data[0]
              ? $store.state.company_data[0]?.file?.file_url ||
                require(`@/assets/logonav.png`)
              : require(`@/assets/logonav.png`)
          "
          style="max-width: 256px; max-height: 128px"
          class="image-company"
        />
        <!-- <img
          v-else
          src="@/assets/logonav.svg"
          style="max-width: 256px; max-height: 128px;"
        /> -->
      </div>

      <div v-if="$store.state" class="col-12">
        <h1 style="color: #68b281; font-size: 36px">
          {{ $store.state.company_data[0]?.name_en }}
        </h1>
        <!-- <h2 style="color: #68b281">หนองจอก</h2> -->
      </div>
    </div>
    <div class="row cursor-pointer mt-3" @click="fillInLink">
      <div class="col-12 px-3">
        <div class="box-main position-relative">
          <!-- <img src="@/assets/btn1.png" class="w-100" @click="fillInLink" /> -->
          <span
            class="d-flex justify-content-center align-items-center h-100 fs-5"
            style="color: #51646b"
          >
            กรอกข้อมูล
          </span>
          <div
            class="rounded-pill bg-noti text-white position-absolute"
            style="height: 25px; width: 25px; top: -10px; right: -10px"
          >
            {{ noti }}
          </div>
        </div>
      </div>
      <!-- <div class="col-12 px-3">
        <img src="@/assets/mobile/btn2.png" class="w-100" @click="detailLink" />
      </div> -->
      <!-- <div class="col-12 px-3">
        <img src="@/assets/mobile/btn3.png" class="w-100" />
      </div>
      <div class="col-12 px-3">
        <img src="@/assets/mobile/btn4.png" class="w-100" />
      </div> -->
    </div>
    <!-- <div class="row position-relative">
      <div class="col-12">
        <img src="@/assets/mobile/btn1.png" @click="fillInLink" />
          <div
            class="rounded-pill bg-dark text-white position-absolute"
            style="height: 25px; width: 25px; top: 0px"
          >
            12
          </div>
      </div>
      <div class="col-12">
        <img src="@/assets/mobile/btn2.png" @click="detailLink" />
      </div>
      <div class="col-12">
        <img src="@/assets/mobile/btn3.png" />
      </div>
      <div class="col-12">
        <img src="@/assets/mobile/btn4.png" />
      </div>
    </div> -->
  </div>
</template>

<script>
import { httpClient } from "@/token/axios.js";
import { apiURL } from "@/configs/serverConfig";
export default {
  data() {
    return {
      noti: 0,
    };
  },
  created() {
    this.getNotiNotFillin();
  },
  methods: {
    fillInLink() {
      this.$router.push("/buildings");
    },
    detailLink() {
      this.$router.push("/daily-chart");
    },
    async getNotiNotFillin() {
      const url = `${apiURL}/notification/building`;

      try {
        const noti = await httpClient.get(url);
        this.noti = noti.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.box-main {
  border: 2px solid #ebeeef;
  box-sizing: border-box;
  background: #ffffff;
  border: 2px solid #ebeeef;
  border-radius: 6px;
  height: 50px;
  margin-right: auto;
  margin-left: auto;
}

.image-company {
  width: 128px;
  height: 128px;
  object-fit: contain;
}

@media (min-width: 992px) {
  .box-main {
    width: 450px;
  }
}
</style>
